import { defer, type LoaderFunctionArgs } from "react-router-dom";
import type { BannerInfo } from "./common/types";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { getBannerList, getDetail, getSPEIAbTestDetail } from "./common/services";

const DEFAULT_EXPERIMENT_TYPE = "experiment_a";

function getValidBannerList() {
  return getBannerList().then((bannerRes) => {
    const bannerList: BannerInfo[] = Array.isArray(bannerRes.banner)
      ? bannerRes.banner.filter((item) => item.iconUrl && item.linkUrl)
      : [];
    return bannerList;
  });
}

export function speiLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const isUnoNew = url.searchParams.get("useUNO") === "1";

  if (isUnoNew) {
    const experimentType = url.searchParams.get("spei_abtest_version") || DEFAULT_EXPERIMENT_TYPE;

    return defer({
      coreData: resolveLoaderResult(
        getSPEIAbTestDetail(experimentType).then((detail) => ({
          detail,
          experimentType,
        })),
      ),
    });
  }

  return defer({
    coreData: resolveLoaderResult(getDetail()),
    secondaryData: resolveLoaderResult(getValidBannerList()),
  });
}

export function speiExperimentLoader({ request }: LoaderFunctionArgs) {
  const experimentType =
    new URL(request.url).searchParams.get("spei_abtest_version") || DEFAULT_EXPERIMENT_TYPE;

  return defer({
    coreData: resolveLoaderResult(
      getSPEIAbTestDetail(experimentType).then((detail) => ({
        detail,
        experimentType,
      })),
    ),
  });
}
